export default __webpack_public_path__ + "static/media/f3.c2e0ace2.jpg";